import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

function Successfulprojects() {
  return (
    <section className="successful_projects projects_uk p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              Transformative App Development <span>Case Studies</span>
            </h2>
            <p>
              Explore our{" "}
              <Link to="/uk/mobile-app-development-company-uk">
                UK app development
              </Link>{" "}
              case studies. Our team has turned client ideas into
              high-performing digital products for established brands and
              startups. We've revolutionised business operations, enhanced user
              experiences, and boosted engagement to drive revenue, business
              growth, and scalability.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Swiper
              loop={true}
              // autoplay={{
              //   delay: 3000,
              //   disableOnInteraction: false,
              // }}
              autoplay={false}
              spaceBetween={20}
              modules={[Autoplay, Pagination]}
              pagination={{
                clickable: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                768: {
                  slidesPerView: 1,
                },
                1024: {
                  slidesPerView: 1.3,
                },
                1366: {
                  slidesPerView: 1.4,
                },
                1600: {
                  slidesPerView: 1.6,
                },
              }}
              className="web_case_slider"
            >
              <SwiperSlide>
                <div className="web_pro_item item-1">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../../images/services-usa/android-new/projects/pure_plank_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={189}
                        height={60}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Bringing a New Concept to the Health and Fitness Journey
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>40%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>60%</h5>
                        <p>Improvement in Fitness</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/pure-plank"
                        aria-label="TekRevol Contact"
                        className="border_btn"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/case_img/pure_plank.webp"
                      alt="App development company"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-3">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../../images/location_new/uk-mobile/case_img/soundly_logo.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={69}
                        height={75}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>Enabling Music Lovers to Stream Millions of Songs</h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>20%</h5>
                        <p>Increase in Subscription</p>
                      </div>
                      <div className="android_item">
                        <h5>40%</h5>
                        <p>Ad Revenue Increased</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/soundly"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/case_img/soundly.webp"
                      alt="Mobile app development company in UK"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="web_pro_item item-4">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../../images/location_new/uk-mobile/case_img/cmore_logo.png"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={82}
                        height={71}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>Solution to Streamline Procurement Process</h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>18%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>36%</h5>
                        <p>Cost Reduced</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/cmore"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/case_img/cmore.webp"
                      alt="Mobile app development company"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
              {/* <SwiperSlide>
                <div className="web_pro_item item-5">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../../images/location_new/uk-mobile/case_img/fsk_logo_1.png"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={95}
                        height={100}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Bringing a New Concept to the Health and Fitness Journey
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>40%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>60%</h5>
                        <p>Improvement in Fitness</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/fsk"
                        aria-label="TekRevol Contact"
                        className="border_btn"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/case_img/fsk.webp"
                      alt="pure plank"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide> */}
              <SwiperSlide>
                <div className="web_pro_item item-2">
                  <div className="web_pro_content">
                    <div className="web_pro_logo">
                      <StaticImage
                        src="../../../images/location_new/uk-mobile/case_img/yeppy_logo.png"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={200}
                        height={54}
                      />
                    </div>
                    <div className="web_pro_head">
                      <h2>
                        Offering Exclusive Services in One Seamless Platform
                      </h2>
                    </div>
                    <div className="and_head">
                      <h5>Results?</h5>
                    </div>
                    <div className="and_pro_flex">
                      <div className="android_item">
                        <h5>22%</h5>
                        <p>ROI Growth</p>
                      </div>
                      <div className="android_item">
                        <h5>30%</h5>
                        <p>Increase in Productivity</p>
                      </div>
                    </div>
                    <div className="web_pro_btn">
                      <Link
                        to="/case-studies/yeppy"
                        className="border_btn"
                        aria-label="TekRevol Contact"
                      >
                        Read Case Study
                      </Link>
                    </div>
                  </div>
                  <div className="web_pro_img">
                    <StaticImage
                      src="../../../images/location_new/uk-mobile/case_img/yeppy.webp"
                      alt="App development company UK"
                      layout="constrained"
                      placeholder="blurred"
                      formats={["webp"]}
                      width={563}
                      height={677}
                    />
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center"
          >
            <Link
              to="/projects"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Visit our Case Studies
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Successfulprojects;
